<template>
    <div v-if="$root.ready && lang" class="user-menu">
        <div class="user-container container">
            <ul class="row">
                <li class="col" @click="onLinkClick('saved_searches')">
                    <img alt="searches" :src="'/img/icons/' + $root.network + '/searches.svg'" width="31" height="22"/>
                    <span>
                        {{ lang.user_menu.labels.saved_searches }}
                    </span>
                </li>
                <li class="col" @click="onLinkClick('saved_estates')">
                    <img alt="favorites" :src="'/img/icons/' + $root.network + '/favorites.svg'" width="24" height="22" />
                    <span>
                        {{ lang.user_menu.labels.saved_estates }}
                    </span>
                </li>
                <li class="col ico-hidden" @click="onLinkClick('hidden_estates')">
                    <img alt="hidden" :src="'/img/icons/' + $root.network + '/hidden.svg'" width="25" height="22"/>
                    <span>
                        {{ lang.user_menu.labels.hidden_estates }}
                    </span>
                </li>
                <li class="col" @click="onLinkClick($root.user_hash ? 'profile' : 'dashboard')">
                    <img alt="profile" :src="'/img/icons/' + $root.network + '/profile.svg'" width="22" height="22" />
                    <span>
                        {{ profileLabel }}
                    </span>
                </li>
            </ul>
        </div>

        <modal
            name="login"
            ref="login"
            extra-class="bottom-modal login-modal animated fadeInUpBig"
            :auto-open="autoOpenLoginModal"
        >
            <template slot="body" slot-scope="props">
                <login-form-register
                    v-if="config_footer.login_type == 'register'"
                    :target="section"
                    :triggers_an_action="props.data ? props.data.action : null"
                    :login_social="config_footer.login_social"
                />
                <login-form
                    v-else
                    :target="section"
                    :triggers_an_action="props.data ? props.data.action : null"
                    :login_social="config_footer.login_social"
                />
            </template>
        </modal>
    </div>
</template>

<script>
import LoginForm from './LoginForm'
import LoginFormRegister from './LoginFormRegister'
import Modal from './Modal'

import { hasQueryStringParam } from '../helpers/urls'

export default {
    components: {
        'login-form': LoginForm,
        'login-form-register': LoginFormRegister,
        'modal': Modal,
    },

    props: {
        config_footer: {
            type: Object,
            required: false,
        },
    },

    data() {
        return {
            section: null,
        }
    },

    computed: {
        autoOpenLoginModal() {
            return this.is_guest() && hasQueryStringParam('show_login')
        },

        lang() {
            return this.$root.lang.bottom_menu
        },

        profileLabel() {
            let label = this.$root.user_hash ? 'profile' : 'login'

            return this.lang.user_menu.labels[label]
        },
    },

    methods: {
        onLinkClick(section) {
            this.section = section

            if(this.is_guest()) {
                this.openLoginModal(section)

                return
            }

            location.href = this.lang.user_area_routes[section]
        },

        openLoginModal(section) {
            window.events.$emit('showModal', { name: 'login', target: section })
        },
    },
}
</script>